import { SearchResult } from '@/models/Repository'
import DashboardApi from '../api/DashboardApi'

/**
 * 全体ダッシュボードが返すレポートモデル
 */
export class WholeReportModel {
  constructor({
    insertionOrder,
    agencyId,
    advertiserId,
    advertiser,
    serveStatus,
    ioBudgetStartTime,
    ioBudgetEndTime,
    revenueBuyingCurrency,
    remainingBudget,
    remainingDays,
    yesterdayBuyingCurrency,
    dailyBuyingCurrencyPlan,
    yesterdayBudgetProgress,
    status,
  } = {}) {
    this.insertionOrder = insertionOrder
    this.agencyId = agencyId
    this.advertiserId = advertiserId
    this.advertiser = advertiser
    this.serveStatus = serveStatus
    this.ioBudgetStartTime = ioBudgetStartTime
    this.ioBudgetEndTime = ioBudgetEndTime
    this.revenueBuyingCurrency = revenueBuyingCurrency
    this.remainingBudget = remainingBudget
    this.remainingDays = remainingDays
    this.yesterdayBuyingCurrency = yesterdayBuyingCurrency
    this.dailyBuyingCurrencyPlan = dailyBuyingCurrencyPlan
    this.yesterdayBudgetProgress = yesterdayBudgetProgress
    this.status = status
  }

  get isCompleted() {
    return this.remainingBudget <= 0
  }

  get isActive() {
    return this.status === 'active'
  }

  get isLastMinute() {
    return this.remainingDays <= 5
  }
}

WholeReportModel.ServeStatusList = {
  WARNING: 'warning',
  CAUTION: 'caution',
  NOT_SERVE: 'notServe',
  RUN_RATE: 'runRate',
}

/**
 * 全体ダッシュボードデータを取得するクラス
 */
export class WholeReportRepository {
  static async search({
    serveStatus,
    keyword,
    sortBy,
    descending,
    pageNo,
    pageSize,
  } = {}) {
    // とりあえず擬似的にフィルター、ソートする
    const { data, ...rest } = await DashboardApi.fetchWhole({
      serveStatus,
      keyword,
      sort: sortBy,
      sortType: descending ? 'desc' : 'asc',
      pageNo,
      pageSize,
    })
    const items = data.map(item => new WholeReportModel(item))
    return new SearchResult({ ...rest, items, pageSize })
  }
}
